var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "Growth",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.49,18.39A1.51,1.51,0,0,0,52,16.94H39.32a1.5,1.5,0,0,0,0,3h9.44L36.26,34.67l-7.47-8.89a1.51,1.51,0,0,0-1.15-.53,1.49,1.49,0,0,0-1.15.54L10.85,44.6a1.5,1.5,0,0,0,2.3,1.92l14.5-17.43L35.1,38a1.51,1.51,0,0,0,2.3,0L50.5,22.53v8.59a1.5,1.5,0,0,0,3,0C53.49,31.05,53.51,18.45,53.49,18.39Z",
    fill: "#3cb371",
    className: "color000000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.c71ce1ac9dc231fb6d83bae1975aa47e.svg";
export { ForwardRef as ReactComponent };